import * as React from "react"
import { TextStyle, ViewStyle, TouchableOpacity, ImageStyle } from "react-native"
import { observer } from "mobx-react-lite"
import { color } from "../../theme"
import { Text } from "../text/text"
import { JalaIcon } from "../jala-icon/jala-icon"
import moment from 'moment';
import numeral from 'numeral';
import { AutoImage } from "../auto-image/auto-image"
import _ from 'lodash'
import { View } from "native-base"


const MAIN_CONTAINER: ViewStyle = {
  justifyContent: "center",
  borderRadius: 10,
  borderWidth: 1,
  borderColor: color.palette.gray200,
  padding: 8,
  // flex: 1,
  // marginRight: 14,
  width: 220,
  backgroundColor: color.palette.white
}

const TEXT_1: TextStyle = {
  color: color.palette.gray800,
  textTransform: 'capitalize'
}

const TEXT_2: TextStyle = {
  color: color.palette.gray700,
}

const TEXT_3: TextStyle = {
  color: color.palette.blue500,
}

const BORDER: ViewStyle = {
  height: 1,
  backgroundColor: color.palette.gray200,
  marginVertical: 8
}

const ROW_CONTAINER: ViewStyle = {
  flexDirection: 'row',
  marginTop: 8,
  marginBottom: 2
}

const VERIF_ICON: ImageStyle = {
  borderRadius: 30,
  width: 17,
  height: 17,
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: 5
}


const CHANGES = (isMinus): ViewStyle => ({
  backgroundColor: !isMinus ? color.palette.green300 : color.palette.red300,
  borderRadius: 10,
  paddingLeft: 2,
  paddingRight: 8,
  flexDirection: 'row',
  alignItems: 'center',
  marginLeft: 5,
  maxWidth: 100
})

export interface PriceCardProps {
  /**
   * An optional style override useful for padding & margin.
   */
   data?: any
   region?: string
   date?: string,
   name?: string,
   price?: string,
   isVerified?: boolean
   diff?: string
   currency?: string
   onPress?: () => void
}

/**
 * Describe your component here
 */
export const PriceCard = observer(function PriceCard(props: PriceCardProps) {

  const { region, date, name, price, diff, isVerified, currency, onPress, data } = props

  const isMinus = diff && numeral(diff).format('00000') < 0
  const icon = !isMinus ? "arrow_drop_up" : "arrow_drop_down"
  const colors = !isMinus ? color.palette.green500 : color.palette.red500
  const formatDate = moment(date).format('dddd, DD MMM YYYY');
  const isPartner = !_.isEmpty(data) && data.creator && data.creator.state !== null ? (data.creator.state || {}).partner : false;
  const img = isPartner ? require("./mitra-logo.png") : require("./verified.png");

  return (
    <TouchableOpacity style={MAIN_CONTAINER} onPress={onPress}>
      <Text style={TEXT_1} preset="title3" text={region.toLowerCase()} colorScheme="light" />
      <View style={BORDER} />
      <Text style={TEXT_1} preset="body3" text={formatDate} colorScheme="light" />
      <View style={ROW_CONTAINER}>
        {(isVerified || isPartner) && <AutoImage source={img} style={VERIF_ICON} /> || (
          <View bg="gray.200" width="16px" height="16px" rounded="full" justifyContent="center" alignItems="center" mr="4px">
            <JalaIcon name="help-outline" size={12} color={color.palette.gray700} />
          </View>
        )}
        <Text text={name} preset="body3" style={TEXT_2} colorScheme="light" numberOfLines={1} marginRight="10px" />
      </View>
      <View style={ROW_CONTAINER}>
        <Text text={`${currency}${price}`} preset="display3" style={TEXT_3} colorScheme="light" />
        {diff && <View style={CHANGES(isMinus)}>
          <JalaIcon name={icon} size={20} color={colors}/>
          <Text text={`${currency} ${numeral(diff).format('0,0')}`} preset="body3" style={TEXT_2} numberOfLines={1} colorScheme="light" />
        </View>}
      </View>
    </TouchableOpacity>
  )
})
